export const GET_IPS_LIST_REQUEST = "GET_IPS_LIST_REQUEST";
export const GET_IPS_LIST_REQUEST_SUCCESS = "GET_IPS_LIST_REQUEST_SUCCESS";
export const GET_IPS_LIST_REQUEST_ERROR = "GET_IPS_LIST_REQUEST_ERROR";

export const ADMIN_IP_UPDATE_REQUEST = "ADMIN_IP_UPDATE_REQUEST";
export const ADMIN_IP_UPDATE_SUCCESS = "ADMIN_IP_UPDATE_SUCCESS";
export const ADMIN_IP_UPDATE_ERROR = "ADMIN_IP_UPDATE_ERROR";
